import classNames from "classnames"
import React,{ FC } from "react"
import { useNavigate } from "react-router-dom"
import { welfare_leaf } from "~src/constants/network"
import { WelfareItemsType } from "~src/service/welfare/welfare"
import styles from "./index.module.less"

interface WelfareItemProps {
  item: WelfareItemsType
  onExchange: (item:WelfareItemsType) => void
}


const WelfareItem: FC<WelfareItemProps> = ({item, onExchange }) => {
  const navigate = useNavigate()
  const onJump = () => {
    navigate(`/welfare/details/${item.skuId}`)
  }
  const onClick = (event: { stopPropagation: () => void }) => {
    event.stopPropagation();
    onExchange(item)
  }
  return <div className={styles.item} onClick={onJump}>
    <img className={styles.thumbnail} src={item.imgUrl} alt={item.name} />
    <div className={styles["item-rf"]}>
      <div className={classNames(styles.lineTextOverFlow, styles['item-title'])}>{item.name}</div>
      <div className={classNames(styles.lineTextOverFlow, styles['item-desc'])}>{item.desc}</div>
      <div className={styles["item-rf-info"]}>
        <div className={styles["item-rf-info-price"]}>
          <img className={styles.welfare_leaf} src={welfare_leaf} alt="" />
          <span className={styles["item-rf-info-price-num"]}>{item.priceFee}</span>
          <span>{item.priceUnit}</span>
        </div>
        <div className={styles["item-rf-btn"]} onClick={onClick}>
          <span>去兑换</span>
        </div>
      </div>
    </div>
  </div>
}
export default WelfareItem